import React from 'react';
import HomepageBL from '../../homepage/HomepageBL';

export const AvailableAmount = ({ account, availableBalance }) => {
  if (
    (HomepageBL.shouldShowAvailableBalance(account) &&
      account.type === 'current') ||
    account.type === 'credit_card' ||
    account.type === 'savings'
  ) {
    return (
      <div className="type--jura cardsticky__hide">
        {availableBalance} available
      </div>
    );
  }

  return null;
};
